import clsx from 'clsx';
import type { MagazineStageBoxProps } from './interfaces';
import styles from './MagazineStageBox.module.scss';

const MagazineStageBox = ({
  children,
  className,
  category,
}: MagazineStageBoxProps) => {
  return (
    <div className={styles.wrapper1}>
      <div className={styles.wrapper2}>
        <div className={clsx(styles.base, category, className)}>
          <div className={styles.contentBox}>{children}</div>
          <div className={styles.skew} />
        </div>
      </div>
    </div>
  );
};

export default MagazineStageBox;
